import { makeMessages, makeTranslation } from 'utils'

const messages = {
  home: 'home',
  categories: 'categories',
  templates: 'templates',
  offers: 'offers',
  orders: 'orders',
  invoices: 'invoices',
  orderIn: 'orderIn',
  tomorrow: 'tomorrow',
  day: 'day',
  days: 'days',
  promo: 'promo',
  allProducts: { id: 'products.header.allProducts' },
  categoriesTab: { id: 'categories.title' },
  cuisinesTab: {
    id: 'filter.cuisines',
  },
  login: { id: 'login.submit' },
  cancelActivation: { id: 'profile.activate2FA.cancel' },
  cancelDeactivation: { id: 'profile.deactivate2FA.cancel' },
}

export default makeMessages(messages, makeTranslation('navbar'))
